module.exports = __webpack_public_path__ + "static/media/reset-password.4912467f.svg";